/**
 * Detect user intent to prioritize Applications / app configuration ahead of other work.
 */

export const APPS_FIRST_DEFAULT_PATH = "Applications > OIDC";

export const APPS_FIRST_INTENT_CHIPS = Object.freeze([
  {
    id: "intent-create-oidc-app",
    label: "Create OIDC App",
    description: "Register a new OIDC client integration",
  },
  {
    id: "intent-configure-saml",
    label: "Configure SAML",
    description: "Federation, metadata, and sign-on URLs",
  },
  {
    id: "intent-add-servicenow-oin",
    label: "Add ServiceNow (OIN)",
    description: "Provision SAML app from catalog",
  },
  {
    id: "intent-browse-app-catalog",
    label: "Browse App Catalog",
    description: "Okta Integration Network and catalog apps",
  },
]);

/** Primary headline when user pivots to apps-first (Command window). */
export const APPS_FIRST_INTENT_HEADLINE = "Applications · App configuration";

export function detectAppsFirstIntent(text) {
  const s = String(text || "").toLowerCase().trim();
  if (!s) return false;

  const patterns = [
    /configure\s+(the\s+)?apps?\s+first/,
    /(\bi\s+)?would\s+like\s+to\s+configure\s+(the\s+)?apps?\s+first/,
    /apps?\s+first/,
    /applications?\s+first/,
    /start\s+with\s+(the\s+)?apps?/,
    /priorit(?:y|ize)\s+apps?/,
    /(\bi\s+)?want\s+to\s+configure\s+(the\s+)?apps?/,
    /focus\s+on\s+(the\s+)?apps?/,
  ];
  return patterns.some((p) => p.test(s));
}

/**
 * App-related write for Okta integrations (Application Administrator, API AM, or org admin via tabAccess).
 * @param {object | null} caps conversationMemory.currentCapabilities
 */
export function hasApplicationIntegrationWrite(caps) {
  if (!caps?.userId || !caps.tabAccess) return false;
  const oidc = caps.tabAccess.OIDC;
  const saml = caps.tabAccess.SAML;
  const apps = caps.tabAccess.Apps;
  return Boolean((oidc && oidc.canWrite) || (saml && saml.canWrite) || (apps && apps.canWrite));
}
